import { makeStyles } from '@mui/styles';

export const subAdmin = [ 'Operations','Customer Supports','Marketing','Accounts','Designer','Data Analyst','Human Resources HR']
export const AccessLevel = [
    {
        id:1,
        level_name:'ADMIN',
        level_access:100
    },
    {
        id:3,
        level_name:'SUB ADMIN 1',
        level_access:60
    },
    {
        id:2,
        level_name:'SUB ADMIN 2',
        level_access:50
    },
    {
        id:4,
        level_name:'CUSTOMER SUPPORT',
        level_access:30
    },
    {
        id:5,
        level_name:'HOLD TRADING',
        level_access:20
    },
    {
        id:6,
        level_name:'SUB ADMIN 3',
        level_access:10
    },
  
    
]

export const ACCESS_LEVEL = {
    ADMIN: 100,
    SUB_ADMIN2: 50,
    SUB_ADMIN1: 60,
    CUSTOMER_SUPPORT: 30,
    HOLDTRADING:20,
    SUB_ADMIN3: 10
}

export const useStyles = makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: '1px solid #ccc',
      }}
});


export const PREDICTION_TYPE_GST = {
    POLL: 1,
    OPINION_PRO: 2,
    TRADING: 3,
    QUIZ_PLAY: 4,
    SKILLER: 5
}
export const PREDICTION_TYPE =
["MATCH", "OVERS", "WICKETS","PLAYERS","OTHERS"]